export const FinishCheckGreenSVG = (props) => (
  <svg
    height={10}
    viewBox="0 0 15 10"
    width={10}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 3.906L5.847 9l7.961-8"
      fill="none"
      stroke="#07B323"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);
